import { Component } from '@angular/core';
import { DialogPage } from '../../../../lib/common/common.data';
import { ScepServerInfo } from '../scep.data';
import { ScepService } from '../scep.service';
import { IScepFuncCtrl } from './scep-func.def';
import { VirtualDlgComponent } from 'app/content/virtual/dlg/virtual-dlg.component';
import { AccountService } from 'app/entry/account.service';

@Component({
    templateUrl: './scep-dlg-add.component.html',
    styleUrls: ['../scep.style.css']
})
export class ScepAddDlgComponent extends VirtualDlgComponent implements IScepFuncCtrl {
    title: string;
    funcName: string;
    scepList: ScepServerInfo[];
    other?: any;
    onActionCompleted: (ret: { funcName: string; isFault: boolean; data?: any; errorMessage?: string; }) => void;
    
    _scep: ScepServerInfo = new ScepServerInfo();
    _scepModified: ScepServerInfo;

    _page: DialogPage = DialogPage.action;
    _enumPage: typeof DialogPage = DialogPage;
    _errorMessage: string;
    
    constructor(protected accountSvc: AccountService, private scepSvc: ScepService) { super(accountSvc); }

    onScepUpdate(scep: ScepServerInfo): void {
        this._scepModified = scep;
    }

    create(): void {
        this._page = DialogPage.submit;
        this._errorMessage = null;

        this.scepSvc.createScep(this._scepModified).subscribe((res: { scep: ScepServerInfo, isFault: boolean, errorMessage?: string }) => {
            this._page = DialogPage.result;
            this._errorMessage = res.errorMessage;
            
            if (!res.isFault) {
                setTimeout(() => {
                    this._dlgCloseElementRef.nativeElement.click();
                }, 0);
            }
        });
    }
}